import { debounce } from "lodash";
import { getTimestamp } from "utils/common";

const TIMEOUT = 10000;

export default class LoadingMgr {
  constructor() {
    this.hideLoading = debounce(this.hideLoadingHandler, 0);
  }

  static instance = null;

  static createInstance() {
    const object = new LoadingMgr();
    return object;
  }

  static getInstance() {
    if (!LoadingMgr.instance) {
      LoadingMgr.instance = LoadingMgr.createInstance();
    }
    return LoadingMgr.instance;
  }

  lastTime = getTimestamp();

  status = false;

  waiter = 0;

  hideLoadingHandler = () => {
    let spinner = null;
    let count = 0;
    if (this.waiter > 0) return;
    while (!spinner && count <= 0) {
      spinner = document.getElementById("overlay_spinner");
      if (spinner) spinner.style.display = "none";
      count += 1;
    }
  };

  // auto hide loading affter timeout
  setOff() {
    setTimeout(() => {
      const currentTime = getTimestamp();
      if (this.status) {
        const overTime = currentTime - this.lastTime > TIMEOUT;
        if (overTime) {
          this.hideLoadingHandler();
        }
      }
    }, TIMEOUT);
  }

  setLoading(show) {
    const spinner = document.getElementById("overlay_spinner");

    const setValue = () => {
      if (show) {
        if (spinner) spinner.style.display = "block";
      } else this.hideLoading();
    };

    if (spinner) setValue();
    else setTimeout(() => setValue(), 0);
  }

  setSpinner(visible) {
    this.status = visible;
    if (visible) {
      this.lastTime = getTimestamp();
      this.setOff();
    }
    if (visible) {
      this.waiter += 1;
      this.setLoading(true);
    } else {
      this.waiter -= 1;
      if (this.waiter <= 0) {
        this.setLoading(false);
        this.waiter = 0;
      }
    }
  }
}
